import { api } from "@/shared/api";
import type { components } from "@/lib/api/generated";
import type { Override } from "@/shared/lib/typeOverride";

// 0926 第八批 Z3:真 spec 不带可空信息;旧手写契约里可空的字段在这里补回 | null(见 Override 头注)。
export type ProfileData = Override<
  components["schemas"]["ProfileResponse"],
  {
    email: components["schemas"]["ProfileResponse"]["email"] | null;
    displayName: components["schemas"]["ProfileResponse"]["displayName"] | null;
    phone: components["schemas"]["ProfileResponse"]["phone"] | null;
    avatarUrl: components["schemas"]["ProfileResponse"]["avatarUrl"] | null;
    lastLoginAt: components["schemas"]["ProfileResponse"]["lastLoginAt"] | null;
  }
>;
export type UserPreference = Override<
  components["schemas"]["UserPreferenceDto"],
  { avatarUrl: components["schemas"]["UserPreferenceDto"]["avatarUrl"] | null }
>;

/** 个人中心数据访问。全部走 /me/**(任意登录用户,self scope)。 */
export const profileService = {
  getProfile() {
    return api.get<ProfileData>("/me");
  },

  updateProfile(data: { displayName: string; phone: string; email: string }) {
    return api.put<ProfileData>("/me/profile", data);
  },

  changePassword(oldPassword: string, newPassword: string) {
    return api.put<void>("/me/password", { oldPassword, newPassword });
  },

  getPreferences() {
    return api.get<UserPreference>("/me/preferences");
  },

  savePreferences(data: Partial<UserPreference>) {
    return api.put<UserPreference>("/me/preferences", data);
  },

  uploadAvatar(file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return api.post<{ avatarUrl: string }>("/me/avatar", fd);
  },
};
